import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';
import { ClientTypeCard } from './ClientTypeCard';

const clientTypes = [
    {
        type: 'Type 1',
        title: 'Solo Agents',
        paragraphs: [
            "You're doing everything. And you're exhausted. You generate business, close deals, and keep clients happy. You're also doing your own follow-up, your own admin, your own everything. You've convinced yourself your clients need you specifically - that nobody else can do it right.",
            "Maybe you tried a local assistant. Maybe you tried a VA. It didn't work - and now you've written off the whole idea.",
            "Here's what actually happened: you got the wrong process, not the wrong person.",
            "What you need is a seasoned VA, a defined role, and a system that runs without you in the middle of it. More time. Better margin. A business that serves your life instead of consuming it.",
        ],
        href: '/who-we-serve#solo-agents',
        ctaLabel: "I'm a Solo Agent",
        testId: 'solo-agents-card',
        ctaTestId: 'solo-agents-cta',
        delay: 0,
    },
    {
        type: 'Type 2',
        title: 'Team Leaders',
        paragraphs: [
            "You're running a team and still doing two jobs. On paper, your team looks profitable. But pull your personal production out of the numbers and ask yourself: could this business survive without you selling?",
            "Most team leaders already know the answer. The team itself - after splits, admin salaries, software, and lead spend - often nets 10 to 15 cents on the dollar. The rest is carried by the owner staying in production. Which means you're not running a business. You're running a job with employees.",
            "You built a team to buy your time back. Instead you're working two full-time roles - rainmaker and operator - and neither one is getting your full attention.",
            "The path to a team that actually works without you starts with the right support infrastructure at a price point that doesn't eat your margin.",
        ],
        href: '/who-we-serve#team-leaders',
        ctaLabel: 'I Run a Team',
        testId: 'team-leaders-card',
        ctaTestId: 'team-leaders-cta',
        delay: 0.15,
    },
];

export function TwoClientTypes() {
    return (
        <section data-testid="two-client-types" className="bg-navy-900 py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-14">
                    <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-white mb-4 tracking-tight">
                        We Work With Two Types of Operators.{' '}
                        <span className="text-gold-400">The Pain Is the Same.</span>
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {clientTypes.map((c) => (
                        <ClientTypeCard
                            key={c.title}
                            type={c.type}
                            title={c.title}
                            paragraphs={c.paragraphs}
                            href={c.href}
                            ctaLabel={c.ctaLabel}
                            testId={c.testId}
                            ctaTestId={c.ctaTestId}
                            delay={c.delay}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
